import React, { Fragment } from 'react';
import { Row, Col, Button, Table } from 'antd';
import { UsergroupAddOutlined } from '@ant-design/icons';
import AppLoader from '@sharedComponent/loaders/app-loader';

const AffiliateCommissionProfilePresentational = ({
	columns,
	history,
	affiliateByIDCommissionProfileLoading,
	affiliateByIDCommissionProfileData = [],
	affId,
	affiliateId,
}) => {
	return (
		<Col style={{ marginTop: '10px' }} xl={24} className="commission_profile_box">
			<Row className="commission_profile_title_area">
				<Col className="commission_title">Commission Profiles</Col>
				<Col className="commission_title_button" onClick={() => history.push(`/campaign/add/${affId}/${affiliateId}`)}>
					<UsergroupAddOutlined /> ADD CAMPAIGN
				</Col>
			</Row>

			<Col className="com_body">
				{affiliateByIDCommissionProfileLoading ? (
					<Col style={{ minHeight: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<AppLoader width="5%" height="5%" />
					</Col>
				) : (
					<Col className="affiliate_commission_table">
						<Table
							pagination={{
								position: ['bottomCenter', 'bottomCenter'],
								defaultPageSize: 5,
								showSizeChanger: true,
								pageSizeOptions: ['5', '10'],
							}}
							dataSource={affiliateByIDCommissionProfileData || []}
							columns={columns}
						/>
					</Col>
				)}
			</Col>
		</Col>
	);
};

export default AffiliateCommissionProfilePresentational;
